import './index.css';
import { jsx } from 'react/jsx-runtime';
import { SegmentedProgressBar } from './SegmentedProgressBar.js';
import { SingleProgressBar } from './SingleProgressBar.js';
import { ProgressBarSkeleton } from './Skeleton.js';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import 'react';
import 'classnames';
import './progress-bar-CO7jmyT5.js';

const ProgressBarComponent = (props) => {
    const isSegmented = props.segments !== undefined;
    return isSegmented ? jsx(SegmentedProgressBar, { ...props }) : jsx(SingleProgressBar, { ...props });
};
const ProgressBar = enrichWithSkeleton(ProgressBarComponent, ProgressBarSkeleton);

export { ProgressBar, ProgressBarComponent };
//# sourceMappingURL=ProgressBar.js.map
